import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './index.css';
import App from './App';
import { CustomProvider } from 'rsuite';
import {setupOTelSDK} from "./otel";
import { ThemeProvider, useTheme } from './context/ThemeContext';

setupOTelSDK();

const AppWithTheme = () => {
  const { isDarkMode } = useTheme();

  return (
    <CustomProvider theme={isDarkMode ? 'dark' : 'light'}>
      <App />
    </CustomProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
